import React from 'react';
import { connect } from 'react-redux'
import Area from './configuratorElements/Area.react';
import PageCss from './configuratorElements/PageCss.react';
import MenuLayouts from './configuratorElements/MenuLayouts.react';
import Modal from 'react-modal';
import {FormattedMessage} from 'react-intl';

class ConfiguratorPage extends React.Component {

    static get defaultProps() {
        return {
            ConfiguratorManager: {}
        }
    }
    constructor () {
        super();
        this.state = {
            scaleStyle: { transform: 'scale(1)' },
            copyWarningModalOpen: false,
            didShowCopyWarning: false,
        };

        this.closeCopyWarningModal = this.closeCopyWarningModal.bind(this);
    }

    componentWillMount() {
        this.calcScale();
        const { ConfiguratorManager  } = this.props;

    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.calcScale.bind(this));
    }

    componentDidUpdate() {
        this.calcScale();
        const { ConfiguratorManager  } = this.props;

    }

    calcScale() {
        window.requestAnimationFrame(function() {
            if (this.refs.test) {

                let windowHeight = window.innerHeight;
                let main = document.querySelector('.configurator-main');
                let scaleWidth = (main.offsetWidth - 20) / this.refs.test.offsetWidth;
                let scaleHeight = 1;
                let scaleHeightMarginLeft;
                let scale;

                if(main.offsetHeight > windowHeight * 0.85) {
                    scaleHeight = windowHeight * 0.85 / this.refs.test.offsetHeight;
                    scaleHeightMarginLeft = (main.offsetWidth - (this.refs.test.offsetWidth * scaleHeight)) / 2;
                }

                if(scaleHeight < scaleWidth) {
                    scale = scaleHeight;
                    this.refs.test.style.marginLeft = scaleHeightMarginLeft + "px";
                } else {
                    this.refs.test.style.marginLeft = "";
                    scale = scaleWidth;
                }

                if (scale > 1) scale = 1;
                if ('scale(' + scale + ')' !== this.state.scaleStyle.transform) {
                    this.setState({scaleStyle: {transform: 'scale(' + scale + ')'}});
                }
            }
        }.bind(this));
    }

    closeCopyWarningModal() {
        this.setState({copyWarningModalOpen: false});
    }

    render() {


        this.calcScale();
        window.addEventListener("resize", this.calcScale.bind(this));

        const { ConfiguratorManager  } = this.props;
        if (ConfiguratorManager.getCopyState()==1 && this.state.didShowCopyWarning===false) {
            this.state.copyWarningModalOpen = true;
            this.state.didShowCopyWarning= true;
        }
        const page =  ConfiguratorManager.getPage();
        const pageId = page ? page.id : null;
        const pageVariant = ConfiguratorManager.getPageVariant(page);
        const pageVariantId = pageVariant ? pageVariant.id : null;
        const pageRefId = (page && page.ref) ? page.ref : null;

        // Build CSS classname
        let pageClassName = 'shadow page-a4 configurator-page--';
        if (pageRefId) {
            pageClassName += pageRefId; // set the referenced-ID on copied pages!
        } else {
            pageClassName += pageId;
        }
        if (pageVariantId) {
            pageClassName += ' configurator-page-variant--' + pageVariantId;
        }

        const areaKey = pageId + pageVariantId;

        return (
            <div>
                <MenuLayouts ConfiguratorManager={ConfiguratorManager} />
                <page ref="test" className={pageClassName} style={this.state.scaleStyle}>
                    <PageCss css={ConfiguratorManager.getDocumentCss()} />
                    {
                        ConfiguratorManager.getAreas().map(function (areaEntry, i) {
                            return <Area key={areaKey + i} area={areaEntry} ConfiguratorManager={ConfiguratorManager} /> // key must be an unique identifier, otherwise react doesnt render if page switch :(
                        })
                    }
                </page>

                <Modal
                    className="Modal__Bootstrap modal-dialog"
                    closeTimeoutMS={150}
                    isOpen={this.state.copyWarningModalOpen}
                    onRequestClose={this.closeCopyWarningModal}
                >
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="close" onClick={this.closeCopyWarningModal}>
                                <span aria-hidden="true">&times;</span>
                                <span className="sr-only"><FormattedMessage id="LABEL_CLOSE"/></span>
                            </button>
                            <h4 className="modal-title"><FormattedMessage id="LABEL_WARNING"/></h4>
                        </div>
                        <div className="modal-body">
                            <p><FormattedMessage id="TEXT_COPY_HAS_MODIFIED_ELEMENTS"/></p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default"
                                    onClick={this.closeCopyWarningModal}>
                                <FormattedMessage id="LABEL_CLOSE"/></button>
                        </div>
                    </div>
                </Modal>

            </div>

        )
    }
}

export default connect(state => ({ configurator: state.configurator }))(ConfiguratorPage);



// WEBPACK FOOTER //
// ./src/js/components/ConfiguratorPage.react.jsx